import { convertSnakeToCamelCase } from 'utils/convertSnakeToCamelCase';

export const translateInsurance = (rawObj: object) =>
  convertSnakeToCamelCase(rawObj);
